import _get from 'lodash/get';
import smbUtils from './smbUtils';
import langUtils from './langUtils';
import i18n from 'i18next';

const getSubscriptionType4PurchaseNow = st =>
  st === 'ESSENTIAL_TRIAL' ? 'ESSENTIAL' : 'PREMIUM';

const prefix =
  smbUtils.getUrl() + langUtils.convertToFrontendLangUrl(i18n.language);

const utils = {
  isTrialPlan: si => _get(si, 'subscription.isTrialPlan', false),
  isPremiumPlan: si => _get(si, 'subscription.isPremiumPlan', false),
  getSolutionType: si => _get(si, 'subscription.solutionType'),
  getLeftDays: si => _get(si, 'leftDays', 0),
  isOverdue: si => _get(si, 'overdue', false),
  isRenewable: si => {
    const value = _get(si, 'subscription.isRenewable');
    return value === 'True' || value === 'true' || value === true;
  },
  getSubscriptionType: si =>
    _get(si, 'subscription.subscriptionType', 'ESSENTIAL_TRIAL'),
  getMaxNumberOfSkus: si => _get(si, 'numOfSkus', 0),
  getMaxNumberOfLooks: si => _get(si, 'numOfLooks', 0),
  getMaxNumberOfLicenses: si => _get(si, 'numOfLicenses', 0),
  getMaxNumberOfStaffAccounts: si => _get(si, 'numOfStaffs', 0),
  getPurchaseNowUrl: (si, campaign = 'subscribe-now', customerId = '') =>
    `${prefix}${smbUtils.frontendLanguage()}/business/user/sign-up?platform=STANDARD&isSubscribe=true&currencyType=USD&subscriptionType=${getSubscriptionType4PurchaseNow(
      utils.getSubscriptionType(si)
    )}&recurringType=ANNUAL&utm_source=smb&utm_campaign=${campaign}&utm_content=${customerId}`,
  isEnterprise: si => {
    return utils.getSubscriptionType(si) === 'ENTERPRISE';
  },
};

export default utils;
